var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "main-internal-section width-full float-l" }, [
      _c(
        "div",
        { staticClass: "container" },
        [
          _vm.cantAccessPage === true
            ? [
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    {
                      staticClass: "col-12 col-sm-12 col-md-4 col-lg-4 col-lg-4"
                    },
                    [
                      _c("div", { staticClass: "row" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "header-section col-12 float-l bgcolor-cfe3ee"
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "back-btn-chat float-l" },
                              [
                                _c(
                                  "a",
                                  {
                                    attrs: { href: "javascript:void(0)" },
                                    on: {
                                      click: function($event) {
                                        return _vm.backChatList()
                                      }
                                    }
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "hi-icon icon-chatback"
                                    })
                                  ]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "customer-name float-l colpie-87"
                              },
                              [
                                _c(
                                  "p",
                                  {
                                    staticClass:
                                      "user-avtar-img float-l font-roboto-bold heading-text-14 line-height-16 bgcolor-d7b081 color-white"
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm._f("filtersGetName")(
                                            _vm.email,
                                            _vm.name
                                          )
                                        ) +
                                        " "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "p",
                                  {
                                    staticClass:
                                      "color-231f20 font-roboto-bold heading-text-16 line-height-20 agent-customer-name float-l width-full pt_1 pl_90 mb_0"
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.name) +
                                        " \n                                        "
                                    ),
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "color-58595b font-benton-medium heading-text-11 line-height-15 float-l width-full pt_2"
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(_vm.sections) +
                                            " (" +
                                            _vm._s(_vm.role) +
                                            ") "
                                        )
                                      ]
                                    )
                                  ]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _vm._m(0),
                            _vm._v(" "),
                            _vm.role == "guest" || _vm.role == "Guest"
                              ? _c(
                                  "div",
                                  { staticClass: "menu-right-header float-r" },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "nc-chat-right-dropdown" },
                                      [
                                        _c("div", { staticClass: "dropdown" }, [
                                          _vm._m(1),
                                          _vm._v(" "),
                                          _c(
                                            "ul",
                                            { staticClass: "dropdown-menu" },
                                            [
                                              _vm._m(2),
                                              _vm._v(" "),
                                              _vm._m(3),
                                              _vm._v(" "),
                                              _c("li", [
                                                _c(
                                                  "a",
                                                  {
                                                    attrs: {
                                                      href: "javascript:void(0)"
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.sendMessage(
                                                          "EndChat"
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _vm._v(" End Chat "),
                                                    _vm._m(4)
                                                  ]
                                                )
                                              ])
                                            ]
                                          )
                                        ])
                                      ]
                                    )
                                  ]
                                )
                              : _vm._e()
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "chat-btm-section-main chat-listing-main-mobile width-full float-l message-height"
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "chat-detail-main col-12 float-l"
                              },
                              [
                                _vm._l(_vm.messageArray, function(
                                  message,
                                  index
                                ) {
                                  return _vm.messageArray &&
                                    _vm.messageArray.length > 0
                                    ? [
                                        message.fromId != _vm.logingId
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "user-chat-main colpie-85 float-l"
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "user-img float-l"
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "chat-user-name font-benton-bold heading-text-14 line-height-14 radius-100 bgcolor-71c1c5 bold absolute color-white"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                                                    " +
                                                            _vm._s(
                                                              _vm._f(
                                                                "filtersGetName"
                                                              )(
                                                                _vm.email,
                                                                _vm.name
                                                              )
                                                            ) +
                                                            "\n                                                "
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "user-massage float-l width-full"
                                                  },
                                                  [
                                                    _c(
                                                      "p",
                                                      {
                                                        staticClass:
                                                          "message-content color-333333 heading-text-14 line-height-20 float-l bgcolor-eff1f1 font-text-regular-benton radius-5 pt_10 p_12 mb_0"
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              message.message
                                                            ) +
                                                            " "
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "p",
                                                      {
                                                        staticClass:
                                                          "date color-888888 heading-text-11 line-height-16 float-l width-full font-text-regular-benton mb_0 pt_5 pl_12"
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm._f(
                                                                "filterDate"
                                                              )(
                                                                message.created_date
                                                              )
                                                            ) +
                                                            " "
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          : _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "admin-chat-main colpie-82 float-r"
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "user-massage float-r width-full"
                                                  },
                                                  [
                                                    _c(
                                                      "p",
                                                      {
                                                        staticClass:
                                                          "message-content color-333333 heading-text-14 line-height-20 float-r bgcolor-d6eef5 font-text-regular-benton radius-5 pt_10 p_12 mb_0"
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              message.message
                                                            ) +
                                                            " "
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "p",
                                                      {
                                                        staticClass:
                                                          "date color-888888 heading-text-11 line-height-16 float-r right width-full font-text-regular-benton mb_0 pt_5 pr_12"
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm._f(
                                                                "filterDate"
                                                              )(
                                                                message.created_date
                                                              )
                                                            ) +
                                                            " "
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                      ]
                                    : _vm._e()
                                }),
                                _vm._v(" "),
                                _vm.isHideType
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "message-typing float-r width-full"
                                      },
                                      [_vm._m(5)]
                                    )
                                  : _vm._e()
                              ],
                              2
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "btm-chat-textarea float-l col-12" },
                          [
                            _c("textarea", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.messageData,
                                  expression: "messageData"
                                }
                              ],
                              staticClass: "form-control",
                              attrs: {
                                id: "msgTextArear",
                                type: "text",
                                placeholder: "Type your message here...",
                                name: "message"
                              },
                              domProps: { value: _vm.messageData },
                              on: {
                                input: [
                                  function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.messageData = $event.target.value
                                  },
                                  function($event) {
                                    return _vm.typingEvent()
                                  }
                                ]
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "send-message-btn float-l" },
                              [
                                _c(
                                  "a",
                                  {
                                    attrs: { href: "javascript:void(0)" },
                                    on: {
                                      click: function($event) {
                                        return _vm.sendMessage("Chat")
                                      }
                                    }
                                  },
                                  [
                                    _c("i", {
                                      staticClass:
                                        "hi-icon icon-chatplay-button"
                                    })
                                  ]
                                )
                              ]
                            )
                          ]
                        )
                      ])
                    ]
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "modal fade forward-chat-modal",
                    attrs: {
                      id: "basicModal",
                      tabindex: "-1",
                      role: "dialog",
                      "aria-labelledby": "basicModal",
                      "aria-hidden": "true"
                    }
                  },
                  [
                    _c("div", { staticClass: "modal-dialog" }, [
                      _c("div", { staticClass: "modal-content" }, [
                        _c("div", { staticClass: "modal-header" }, [
                          _vm._m(6),
                          _vm._v(" "),
                          _c(
                            "h4",
                            {
                              staticClass: "modal-title",
                              attrs: { id: "myModalLabel" }
                            },
                            [_vm._v("Forward Message To")]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "nc-search" }, [
                            _c(
                              "div",
                              {
                                staticClass: "input-group stylish-input-group"
                              },
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.searchText,
                                      expression: "searchText"
                                    }
                                  ],
                                  staticClass: "form-control fName",
                                  attrs: {
                                    type: "text",
                                    placeholder: "Search",
                                    id: "forName"
                                  },
                                  domProps: { value: _vm.searchText },
                                  on: {
                                    input: [
                                      function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.searchText = $event.target.value
                                      },
                                      function($event) {
                                        return _vm.searchAPI("forwardChat")
                                      }
                                    ]
                                  }
                                }),
                                _vm._v(" "),
                                _c("span", { staticClass: "input-group-addon" })
                              ]
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _vm.userArray && _vm.userArray.length > 0
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "modal-body forward-chat-main float-l width-full p_0"
                              },
                              [
                                _vm._l(_vm.userArray, function(user, index) {
                                  return [
                                    _c(
                                      "div",
                                      {
                                        key: index,
                                        staticClass:
                                          "chat-listing-section-main chat-forward-section pull-left width-full border-none"
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "pull-left width-full p-15 relative"
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "chat-user-name font-benton-bold heading-text-14 line-height-14 radius-100 bgcolor-71c1c5 bold absolute color-white"
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm._f("filtersGetName")(
                                                        user.email,
                                                        user.name
                                                      )
                                                    ) +
                                                    "\n                                                "
                                                ),
                                                _c("span", {
                                                  staticClass:
                                                    "bgcolor-5cbb55 border-white p_5 pull-left absolute r-1 t-1 radius-100"
                                                })
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "right-listing-detail pl_65 pull-left width-full pr_35 custom-checkbox"
                                              },
                                              [
                                                _c(
                                                  "h3",
                                                  {
                                                    staticClass:
                                                      "color-333333 font-benton-bold heading-text-15 line-height-19 float-l width-full mb_3"
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm._f(
                                                            "filterCamelCase"
                                                          )(user.roleName)
                                                        ) +
                                                        "(" +
                                                        _vm._s(user.email) +
                                                        ")"
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "color-8888888 font-benton-medium heading-text-12 line-height-16 float-l width-full"
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm._f(
                                                            "filterCamelCase"
                                                          )(user.sections)
                                                        ) +
                                                        " "
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "radiobutton"
                                                  },
                                                  [
                                                    _c(
                                                      "label",
                                                      {
                                                        staticClass:
                                                          "custom-radio-container"
                                                      },
                                                      [
                                                        _c("input", {
                                                          directives: [
                                                            {
                                                              name: "model",
                                                              rawName:
                                                                "v-model",
                                                              value:
                                                                _vm.radioBtnId,
                                                              expression:
                                                                "radioBtnId"
                                                            }
                                                          ],
                                                          attrs: {
                                                            type: "radio",
                                                            name: "chat"
                                                          },
                                                          domProps: {
                                                            value: user.id,
                                                            checked: _vm._q(
                                                              _vm.radioBtnId,
                                                              user.id
                                                            )
                                                          },
                                                          on: {
                                                            change: function(
                                                              $event
                                                            ) {
                                                              _vm.radioBtnId =
                                                                user.id
                                                            }
                                                          }
                                                        }),
                                                        _vm._v(" "),
                                                        _c("span", {
                                                          staticClass:
                                                            "checkmark"
                                                        })
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ]
                                })
                              ],
                              2
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "chat-forward-btm float-l width-full bgcolor-eff1f1 relative"
                          },
                          [
                            _c(
                              "a",
                              {
                                staticClass: "nc-forward-chat-send",
                                attrs: { href: "javascript:void(0);" },
                                on: {
                                  click: function($event) {
                                    return _vm.forwardMessage()
                                  }
                                }
                              },
                              [
                                _c("i", {
                                  staticClass: "hi-icon icon-chatright-arrow"
                                }),
                                _vm._v(" "),
                                _c("br"),
                                _vm._v(" "),
                                _c("span", [_vm._v("Forward")])
                              ]
                            )
                          ]
                        )
                      ])
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "modal fade forward-chat-modal email-chat-modal",
                    attrs: {
                      id: "basicModal1",
                      tabindex: "-1",
                      role: "dialog",
                      "aria-labelledby": "basicModal1",
                      "aria-hidden": "true"
                    }
                  },
                  [
                    _c("div", { staticClass: "modal-dialog" }, [
                      _c("div", { staticClass: "modal-content" }, [
                        _vm._m(7),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "modal-body email-chat-main float-l width-full p_0"
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "form-group float-l width-full p_15"
                              },
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: "required|email",
                                      expression: "'required|email'"
                                    },
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.emailChat,
                                      expression: "emailChat"
                                    }
                                  ],
                                  staticClass: "form-control custom-select",
                                  attrs: {
                                    type: "email",
                                    name: "email",
                                    placeholder: "Your email address here",
                                    onfocus: "this.placeholder = ''",
                                    onblur:
                                      "this.placeholder = 'Your email address here'"
                                  },
                                  domProps: { value: _vm.emailChat },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.emailChat = $event.target.value
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c("div", { staticClass: "help is-danger" }, [
                                  _vm._v(_vm._s(_vm.emailChat_error_msg))
                                ])
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "chat-forward-btm float-l width-full bgcolor-eff1f1 relative"
                          },
                          [
                            _c(
                              "a",
                              {
                                staticClass: "nc-forward-chat-send",
                                attrs: { href: "javascript:void(0);" },
                                on: {
                                  click: function($event) {
                                    $event.preventDefault()
                                    return _vm.sendChatEmail()
                                  }
                                }
                              },
                              [
                                _c("i", {
                                  staticClass: "hi-icon icon-chatright-arrow"
                                }),
                                _vm._v(" "),
                                _c("br"),
                                _vm._v(" "),
                                _c("span", [_vm._v("Send")])
                              ]
                            )
                          ]
                        )
                      ])
                    ])
                  ]
                )
              ]
            : [_vm.isRequestComplete ? [_vm._m(8)] : _vm._e()]
        ],
        2
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "ul",
      { staticClass: "dropdown-menu-profile middle-chat-query-section" },
      [
        _c("li", [
          _c("p", [
            _c("span", [_c("i", { staticClass: "fa fa-envelope-o" })]),
            _vm._v("  user@gmail.com ")
          ])
        ]),
        _vm._v(" "),
        _c("li", [
          _c("p", { staticClass: "phone-number-sec" }, [
            _c("span", [_c("i", { staticClass: "fa fa-phone" })]),
            _vm._v("  1234567890 ")
          ])
        ]),
        _vm._v(" "),
        _c("li", { staticClass: "query-message" }, [
          _c("p", { staticClass: "query-section" }, [
            _c("span", [
              _c("i", {
                staticClass: "hi-icon icon-chatoval-speech-bubble",
                staticStyle: { "font-weight": "bold" }
              })
            ]),
            _vm._v(" Testing message subject ")
          ])
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      {
        staticClass: "more-btn btn btn-primary dropdown-toggle",
        attrs: { type: "button", "data-toggle": "dropdown" }
      },
      [
        _c("span", { staticClass: "more-dot" }),
        _vm._v(" "),
        _c("span", { staticClass: "more-dot" }),
        _vm._v(" "),
        _c("span", { staticClass: "more-dot" })
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", [
      _c(
        "a",
        {
          attrs: {
            href: "javascript:void(0)",
            "data-toggle": "modal",
            "data-target": "#basicModal1"
          }
        },
        [
          _vm._v(" Email Chat "),
          _c("span", [_c("i", { staticClass: "fa fa-angle-right custom" })])
        ]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", [
      _c(
        "a",
        {
          attrs: {
            href: "javascript:void(0)",
            "data-toggle": "modal",
            "data-target": "#basicModal"
          }
        },
        [
          _vm._v(" Forward Chat "),
          _c("span", [_c("i", { staticClass: "fa fa-angle-right custom" })])
        ]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", [_c("i", { staticClass: "fa fa-angle-right custom" })])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "admin-typing colpie-82 float-l" }, [
      _c("div", { staticClass: "tiblock float-l" }, [
        _c("div", { staticClass: "tidot" }),
        _vm._v(" "),
        _c("div", { staticClass: "tidot" }),
        _vm._v(" "),
        _c("div", { staticClass: "tidot" })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      {
        staticClass: "close",
        attrs: {
          type: "button",
          "data-dismiss": "modal",
          "aria-label": "Close"
        }
      },
      [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modal-header" }, [
      _c(
        "button",
        {
          staticClass: "close",
          attrs: {
            type: "button",
            "data-dismiss": "modal",
            "aria-label": "Close"
          }
        },
        [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
      ),
      _vm._v(" "),
      _c("h4", { staticClass: "modal-title", attrs: { id: "myModalLabel" } }, [
        _vm._v("Email Chat To")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-12" }, [
      _c("div", { staticClass: "error-template" }, [
        _c("h1", [_vm._v("\n                                Oops!")]),
        _vm._v(" "),
        _c("h2", [_vm._v("\n                                403 ")]),
        _vm._v(" "),
        _c("div", { staticClass: "error-details" }, [
          _vm._v(
            "\n                                Sorry!, You don't have permission to access this page.\n                            "
          )
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-05179e02", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-05179e02","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Login/ChatDetail.vue
// module id = null
// module chunks = 